import React, { useState, useEffect } from 'react';
import { formationService } from '../services/formationService';
import { supabase } from '../supabaseClient';
import './Formation.css';

function Formation({ edition: customEdition }) {
  const [formations, setFormations] = useState([]);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedFormation, setSelectedFormation] = useState(null);
  const [showDetail, setShowDetail] = useState(false);
  const [showInscrire, setShowInscrire] = useState(false);
  
  // Registration form state
  const [registrations, setRegistrations] = useState({
    nom: '',
    prenom: '',
    email: '',
    telephone: '',
    organisation: ''
  });
  const [success, setSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    loadData();
  }, [customEdition]);

  const loadData = async () => {
    try {
      setLoading(true);
      let editionYear = customEdition;
      if (!editionYear) {
        const { data: activeEdition } = await supabase
          .from('editions')
          .select('year')
          .eq('is_active', true)
          .single();
        editionYear = activeEdition?.year || '2025';
      }

      const settingsData = await formationService.getSettings(editionYear);
      setSettings(settingsData);
      
      const formationList = await formationService.getFormations(editionYear);
      setFormations(formationList.filter(f => f.is_active));
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleInscrireClick = (formation) => {
    setSelectedFormation(formation);
    setShowInscrire(true);
    setShowDetail(false);
    setSuccess(false);
  };

  const handleDetailClick = (formation) => {
    setSelectedFormation(formation);
    setShowDetail(true);
    setShowInscrire(false);
  };

  const handleInputChange = (e) => {
    setRegistrations({ ...registrations, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await formationService.register({
        ...registrations,
        formation_id: selectedFormation.id,
        edition_id: settings.edition_id
      });
      setSuccess(true);
      setRegistrations({
        nom: '',
        prenom: '',
        email: '',
        telephone: '',
        organisation: ''
      });
      setTimeout(() => setShowInscrire(false), 3000);
    } catch (error) {
      alert('Erreur lors de l’inscription. Veuillez réessayer.');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading || !settings || !settings.is_visible || formations.length === 0) return null;

  return (
    <div id="formations" className="formation-section">
      <div className="formation-container">
        <div className="section-header">
          <h2 className="section-title">{settings.title}</h2>
          <p className="section-subtitle">{settings.subtitle}</p>
        </div>

        <div className="formations-grid">
          {formations.map((formation) => (
            <div key={formation.id} className="formation-card">
              <div className="formation-image-container">
                <img src={formation.image_url || 'https://via.placeholder.com/400x250'} alt={formation.title} className="formation-image" />
                <div className="formation-price">80€</div>
              </div>
              <div className="formation-content">
                <h3 className="formation-title">{formation.title}</h3>
                <p className="formation-description">
                  {formation.description.length > 100 ? formation.description.substring(0, 100) + '...' : formation.description}
                </p>
                <div className="formation-actions">
                  <button className="btn-detail" onClick={() => handleDetailClick(formation)}>Détails</button>
                  <button className="btn-inscrire" onClick={() => handleInscrireClick(formation)}>S’inscrire</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal for Details */}
      {showDetail && selectedFormation && (
        <div className="formation-modal-overlay" onClick={() => setShowDetail(false)}>
          <div className="formation-modal" onClick={e => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setShowDetail(false)}>&times;</button>
            <div className="modal-header">
              <h2>{selectedFormation.title}</h2>
              <span className="modal-price">Prix: 80€</span>
            </div>
            <div className="modal-body">
              <img src={selectedFormation.image_url} alt={selectedFormation.title} className="modal-image" />
              <div className="modal-details">
                <h3>À propos de la formation</h3>
                <p>{selectedFormation.details || selectedFormation.description}</p>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn-inscrire" onClick={() => handleInscrireClick(selectedFormation)}>S'inscrire maintenant</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal for Inscription */}
      {showInscrire && selectedFormation && (
        <div className="formation-modal-overlay" onClick={() => setShowInscrire(false)}>
          <div className="formation-modal registration-modal" onClick={e => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setShowInscrire(false)}>&times;</button>
            <div className="modal-header">
              <h2>Inscription : {selectedFormation.title}</h2>
              <p>Veuillez remplir le formulaire ci-dessous</p>
            </div>
            <div className="modal-body">
              {success ? (
                <div className="success-message">
                  <div className="success-icon">✓</div>
                  <h3>Inscription réussie !</h3>
                  <p>Votre demande a été enregistrée. Nous vous contacterons prochainement.</p>
                </div>
              ) : (
                <form className="registration-form" onSubmit={handleSubmit}>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Nom</label>
                      <input type="text" name="nom" required value={registrations.nom} onChange={handleInputChange} />
                    </div>
                    <div className="form-group">
                      <label>Prénom</label>
                      <input type="text" name="prenom" required value={registrations.prenom} onChange={handleInputChange} />
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Email</label>
                    <input type="email" name="email" required value={registrations.email} onChange={handleInputChange} />
                  </div>
                  <div className="form-group">
                    <label>Téléphone</label>
                    <input type="tel" name="telephone" required value={registrations.telephone} onChange={handleInputChange} />
                  </div>
                  <div className="form-group">
                    <label>Organisation / Université</label>
                    <input type="text" name="organisation" required value={registrations.organisation} onChange={handleInputChange} />
                  </div>
                  <div className="form-footer">
                    <p className="price-note">Prix à régler : <strong>80€</strong></p>
                    <button type="submit" className="btn-submit" disabled={submitting}>
                      {submitting ? 'Envoi...' : 'Valider l’inscription'}
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Formation;
